import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/platform/tenants')({
  staticData: { crumb: 'Editions' },
})
